export const siteConfig = {
  name: '91大事件',
  title: '91大事件 - 历史上的重大时刻全解析',
  description: '91大事件深度盘点，带你回顾历史长河中那些改变世界进程的重大节点。从政治、经济到社会文化，91大事件为你呈现最完整的历史事件脉络与深度解读，助你快速掌握关键历史知识。',
  keywords: '91大事件,91大事件盘点,91大事件历史回顾,91大事件深度解析,91重大历史节点,历史大事件汇总,重大历史事件解读',
  url: 'https://www.91dashijian.com',
  logo: '91大事件',
  about: {
    title: '关于91大事件',
    subtitle: '记录历史，启迪未来',
    story: `<p>91大事件是一个专注于历史重大事件深度解析的知识平台。我们相信，了解历史不仅是回顾过去，更是为了更好地理解现在和预见未来。</p>
<p>在信息碎片化的时代，我们致力于为读者提供系统、全面、深入的历史事件解读。我们的编辑团队由历史学研究者、资深媒体人和专业作家组成，确保每一篇文章都经过严谨的事实核查和专业的编辑加工。</p>
<p>从政治变革到经济危机，从科技进步到文化运动，91大事件覆盖了人类历史上最具影响力的重大节点。我们不仅告诉你"发生了什么"，更帮助你理解"为什么发生"以及"带来了什么影响"。</p>
<p>无论你是历史爱好者、学生还是研究者，91大事件都是你探索历史的最佳伙伴。</p>`,
    mission: '让每一个重大历史事件都被清晰记录和深度解读，帮助人们从历史中汲取智慧。',
    vision: '成为中文世界最具影响力的历史知识平台。',
    values: [
      { title: '严谨求真', description: '每一篇文章都经过严格的事实核查，确保历史信息的准确性。' },
      { title: '深度解读', description: '不仅还原事件本身，更提供多维度的深度分析和历史脉络梳理。' },
      { title: '通俗易懂', description: '用活泼生动的语言讲述历史，让复杂的史实变得易于理解。' },
      { title: '开放包容', description: '呈现多元视角，鼓励理性讨论，尊重不同的历史观点。' },
    ],
    reputation: [
      { number: '500+', label: '深度文章' },
      { number: '50万+', label: '月度读者' },
      { number: '98%', label: '读者好评率' },
      { number: '120+', label: '合作学者' },
    ],
    contact: {
      email: 'contact@91dashijian.com',
      address: '北京市海淀区中关村大街1号',
      wechat: '91大事件',
    },
  },
};